import React from 'react'
import { upperFirst } from 'lodash'
import Label from 'src/components/riders/rider-portal/common/Label'
import { ISimpleDriverDTO } from 'src/types'
import { RIDER_PORTAL_UI_MESSAGES } from 'src/constants/rider-portal'

export interface ITripVehicle {
  color?: string
  id?: string
  licensePlate: string
  make: string
  model: string
  vehicleId: string
}

interface IDriverAndVehicleProps {
  operator: ISimpleDriverDTO
  vehicle: ITripVehicle
}

const DriverAndVehicle = ({ operator, vehicle }: IDriverAndVehicleProps) => {
  const {
    common,
    trips: { details }
  } = RIDER_PORTAL_UI_MESSAGES
  const { firstName, lastName } = operator
  const { color, licensePlate, make, model } = vehicle
  return (
    <div>
      <h4 className='font-black3 font-medium rp-mb8 rp-my0 text-center text-md'>{details.driverAndVehicle}</h4>
      <div className='flex column-gap-12'>
        <Label text={`${common.driver}`} />
        <p className='font-grey8 rp-my0 rp-pt2 text-md'>{`${firstName} ${lastName}`}</p>
      </div>
      <div className='flex column-gap-12 rp-mt8'>
        <Label text={`${common.vehicle}`} />
        <p className='font-grey8 rp-my0 rp-pt2 text-md'>{`${color ? `${upperFirst(color)} -` : ''} ${upperFirst(
          make
        )} ${upperFirst(model)} - ${licensePlate}`}</p>
      </div>
    </div>
  )
}

export default DriverAndVehicle



// WEBPACK FOOTER //
// ./src/components/riders/rider-portal/trips/details/DriverAndVehicle.tsx